import React, { useMemo } from 'react';

import type { AppearanceType } from '@atlaskit/tag';
import { RovoAgentIcon } from '@atlassian/conversation-assistant-ui-components';

import type { EditorAgent } from '../../utils/agents';

type AgentRefinementTagProps =
	| { elemBefore: React.ReactNode; appearance: AppearanceType }
	| undefined;

export function useAgentRefinementTagProps(agent?: EditorAgent) {
	const props = useMemo<AgentRefinementTagProps>(() => {
		if (agent) {
			return {
				elemBefore: (
					<RovoAgentIcon label="" size="small" testId="command-palette-rovo-agent-icon" />
				),
				appearance: 'rounded',
			};
		} else {
			return undefined;
		}
	}, [agent]);

	return props;
}
